<div class="canvas-chat-container">
  <div class="canvas-chat-header">
    <div class="canvas-chat-title">
      <img
        src="../../../../assets/icons/svg/chat.svg"
        alt="Drawer"
        height="25"
        width="25"
      />
      <span class="d-none d-lg-block">{{
        hubService.isEmbededChat ? "" : "Conversations"
      }}</span>
    </div>

    <div class="canvas-chat-action-container">
      <img
        src="../../../../assets/icons/svg/refresh.svg"
        alt="Refresh"
        height="18"
        width="18"
        id="refresh_icon"
        class="canvas-chat-action-button action-icon"
        (click)="hubService.getSessions()"
        (keydown)="hubService.getSessions()"
      />

      <img
        src="../../../../assets/icons/svg/bookmark-on.svg"
        alt="Bookmark"
        height="18"
        width="18"
        id="bookmark_icon"
        class="canvas-chat-action-button action-icon"
        [ngClass]="{
          'active-icon mr-2px': isBookmarkFilterEnabled
        }"
        (click)="isBookmarkFilterEnabled = !isBookmarkFilterEnabled"
        (keydown)="isBookmarkFilterEnabled = !isBookmarkFilterEnabled"
      />

      <img
        src="../../../../assets/icons/svg/chat-share.svg"
        alt="Drawer"
        height="18"
        width="18"
        id="shared_chat_icon"
        class="canvas-chat-action-button action-icon"
        [ngClass]="{
          'active-icon':
            hubService.sessionViewType == viewTypes.SESSIONS_SHARED_WITH_ME
        }"
        (click)="switchViewType()"
        (keydown)="switchViewType()"
      />

      <img
        [src]="
          isSearchVisible
            ? '../../../../assets/icons/svg/search-clear.svg'
            : '../../../../assets/icons/svg/search-icon.png'
        "
        alt="Search"
        height="25"
        width="25"
        id="search_chat_icon"
        class="canvas-chat-action-button action-icon"
        (click)="toggleSearch()"
        (keydown)="toggleSearch()"
      />

      <img
        src="../../../../assets/icons/svg/close-square.svg"
        alt="Drawer"
        height="25"
        width="25"
        id="drawer_close_icon"
        class="canvas-chat-action-button action-icon"
        (click)="hubService.closeDrawer()"
        (keydown)="hubService.closeDrawer()"
      />
    </div>
  </div>

  <div class="canvas-chat-search" *ngIf="isSearchVisible">
    <span class="inputWithIcon">
      <input
        type="search"
        name="search"
        id="search"
        placeholder="Search "
        class="input-label"
        [(ngModel)]="searchQuery"
        (blur)="handleSearchBlur()"
        autofocus
      />
    </span>
  </div>

  <div class="chats-list-container scrollbar-custom-scroll-style">
    <div class="spinner-overlay" *ngIf="hubService.isLoadingSessions">
      <mat-progress-spinner
        class="example-margin"
        [color]="'primary'"
        [mode]="'indeterminate'"
      >
      </mat-progress-spinner>
    </div>

    <ng-container
      *ngIf="
        hubService.sessionViewType == viewTypes.MY_SESSIONS;
        else sharedSessions
      "
    >
      <ng-container *ngIf="(filteredSessions?.length || 0) > 0; else noSession">
        <div
          class="saved-chat-item"
          *ngFor="let session of filteredSessions; let i = index"
        >
          <ng-container
            *ngTemplateOutlet="
              currentSessionTemplate;
              context: {
                session: session,
                filteredSessions: filteredSessions,
                index: i,
                permission: shareAccess.MANAGE_SESSION
              }
            "
          >
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #sharedSessions>
      <p class="shared-title">Shared With You</p>
      <ng-container
        *ngIf="(filteredSharedSessions?.length || 0) > 0; else noSession"
      >
        <div
          class="saved-chat-item"
          *ngFor="let session of filteredSharedSessions; let i = index"
        >
          <ng-container
            *ngTemplateOutlet="
              currentSessionTemplate;
              context: {
                session: session,
                filteredSessions: filteredSharedSessions,
                index: i,
                permission: session.permission
              }
            "
          >
          </ng-container>
        </div>
      </ng-container>
    </ng-template>
  </div>
</div>

<ng-template #noSession>
  <div class="w-100 p-2">
    <div class="no-data-height no-data">
      <div class="no-data">No conversation found</div>
    </div>
  </div>
</ng-template>

<ng-template
  #currentSessionTemplate
  let-session="session"
  let-sessions="filteredSessions"
  let-i="index"
  let-sessionPermission="permission"
>
  <p
    class="chat-time cursor-pointer"
    *ngIf="i === 0 || session.displayDate !== sessions[i - 1].displayDate"
  >
    {{ session.displayDate }}
  </p>

  <ng-container *ngIf="editingIndex == i; else viewMode">
    <div
      class="d-flex align-items-start justify-content-even title-input-container gap-2"
    >
      <input
        #sessionTitleInput
        class="chat-title-input"
        [value]="session.title"
        spellcheck="false"
        autofocus
        (blur)="
          onInputBlur(session, sessionTitleInput); $event.stopPropagation()
        "
        (keydown.enter)="
          saveEdit(session, sessionTitleInput); $event.stopPropagation()
        "
      />

      <div
        class="d-flex gap-3 align-items-center justify-content-between h-100"
      >
        <img
          class="chat-action-icon"
          src="../../../../assets/icons/svg/chat-save.svg"
          alt="Save"
          (click)="
            saveEdit(session, sessionTitleInput); $event.stopPropagation()
          "
          (keydown)="
            saveEdit(session, sessionTitleInput); $event.stopPropagation()
          "
          height="24"
          width="22"
        />

        <img
          class="chat-action-icon"
          src="../../../../assets/icons/svg/cross.svg"
          alt="Close"
          height="20"
          width="20"
          (click)="cancelEdit(); $event.stopPropagation()"
          (keydown)="cancelEdit(); $event.stopPropagation()"
        />
      </div>
    </div>
  </ng-container>

  <ng-template #viewMode>
    <div
      class="d-flex align-items-center justify-content-even titles-container gap-3"
      [class.highlight]="session.highlight"
      id="new_chat_name"
      (click)="
        hubService.getChatMessageForSession(session);
        hubService.closeDrawer();
        $event.stopPropagation()
      "
      (keydown)="hubService.onKeyDown($event)"
    >
      <span class="chat-title cursor-pointer">{{ session.title }}</span>
      <div class="d-flex gap-3 align-items-center justify-content-between">
        <span
          *ngIf="session.isSaving || hubService.isAgentWorking(session._id)"
          class="spinner-border spinner-border-chat me-1"
        ></span>

        <img
          *ngIf="(checkSharedWith(session.shared_with) || 0) > 0"
          src="../../../../assets/icons/svg/users_chat.svg"
          alt="Share"
          height="21"
          width="18"
          class="dropdown-icon opacity-75 cursor-pointer user-select-none"
          matTooltipPosition="above"
          [matTooltipClass]="['header-saved-search-item-theme']"
          matTooltip="{{ getSharedTooltip(session) }}"
        />

        <img
          *ngIf="session.bookmarked"
          class="opacity-75 user-select-none"
          src="../../../../assets/icons/svg/bookmark-on.svg"
          alt="Close"
          height="16"
          width="15"
          matTooltipPosition="above"
          [matTooltipClass]="['header-saved-search-item-theme']"
          matTooltip="Session contains bookmarked chat"
        />

        <div
          [matMenuTriggerFor]="sessionMenu"
          #menuTriggerData="matMenuTrigger"
          (click)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()"
        >
          <img
            class="cursor-pointer action-i"
            *ngIf="(session.user_id?.length || 0) > 0"
            src="../../../../assets/icons/svg/more-vertical.svg"
            alt="more"
            height="19"
            width="15"
          />
          <mat-menu
            #sessionMenu="matMenu"
            class="wgt-150px d-flex align-items-start justify-content-start gap-2"
          >
            <div
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
            >
              <div
                *ngIf="sessionPermission === shareAccess.MANAGE_SESSION"
                (click)="
                  menuTriggerData.closeMenu();
                  helperService.openSessionShareDialog(session);
                  $event.stopPropagation()
                "
                (keydown)="
                  menuTriggerData.closeMenu();
                  helperService.openSessionShareDialog(session);
                  $event.stopPropagation()
                "
                class="session-menu"
              >
                <img
                  src="../../../../assets/icons/svg/users_chat.svg"
                  alt="Share"
                  height="21"
                  width="18"
                  class="dropdown-icon"
                />
                <span> Share </span>
              </div>

              <div
                (click)="
                  menuTriggerData.closeMenu();
                  hubService.getChatMessageForSession(session);
                  $event.stopPropagation()
                "
                (keydown)="
                  menuTriggerData.closeMenu();
                  hubService.getChatMessageForSession(session);
                  $event.stopPropagation()
                "
                class="session-menu"
              >
                <img
                  src="../../../../assets/icons/svg/refresh.svg"
                  alt="Share"
                  height="17"
                  width="18"
                  class="dropdown-icon"
                />
                <span> Refresh </span>
              </div>

              <div
                *ngIf="sessionPermission === shareAccess.MANAGE_SESSION"
                (click)="menuTriggerData.closeMenu(); startEdit(i)"
                (keydown)="menuTriggerData.closeMenu(); startEdit(i)"
                class="session-menu"
              >
                <img
                  src="../../../../assets/icons/svg/edit.svg"
                  alt="Rename"
                  height="21"
                  width="17"
                  class="dropdown-icon"
                />
                <span> Rename </span>
              </div>

              <div
                *ngIf="sessionPermission === shareAccess.MANAGE_SESSION"
                (click)="
                  menuTriggerData.closeMenu();
                  hubService.deleteSessionConfirmation(session);
                  $event.stopPropagation()
                "
                (keydown)="hubService.onKeyDown($event)"
                class="session-menu delete"
              >
                <img
                  src="../../../../assets/icons/svg/garbage-delete.svg"
                  alt="Delete"
                  height="15"
                  width="18"
                  class="dropdown-icon"
                />
                <span> Delete </span>
              </div>
            </div>
          </mat-menu>
        </div>
      </div>
    </div>
  </ng-template>
</ng-template>
